document.addEventListener("DOMContentLoaded", function() {
    const profileTab = document.querySelector("#right-container .profile-tab");
    if (!profileTab) return
    const htmlElements = {
        companyName: profileTab.querySelector(".main-info .company-name"),
        logo: profileTab.querySelector(".main-info img"),
        ticker: profileTab.querySelector(".ticker-value"),
        description: profileTab.querySelector(".description-value"),
        address: profileTab.querySelector(".address-value"),
        sectorLogo: profileTab.querySelector(".sector-block img"),
        sectorName: profileTab.querySelector(".sector-block .sector-name"),
        sectorDot: profileTab.querySelector(".sector-block .dot"),
        employees: profileTab.querySelector(".employees-value"),
        exchange: profileTab.querySelector(".exchange-value"),
        type: profileTab.querySelector(".type-value"),
    }
    
    // Add error handler for company logo to hide it if 404/fail
    if (htmlElements.logo) {
        htmlElements.logo.onerror = function() {
            this.style.display = 'none';
        };
    }
    const noStockMessage = profileTab.querySelector(".no-stock-selected-message");
    const profileContent = profileTab.querySelectorAll(".main-info, .ticker-block, .standard-block, .sector-block");

    function updateStockSelectionState(hasStock) {
        if (noStockMessage) {
            if (hasStock) {
                noStockMessage.style.display = 'none';
                profileContent.forEach(el => {
                    if (el) el.style.display = '';
                });
            } else {
                noStockMessage.style.display = 'flex';
                profileContent.forEach(el => {
                    if (el) el.style.display = 'none';
                });
            }
        }
    }

    function checkStockSelection() {
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        let hasStock = false;
        
        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            hasStock = !!ticker;
        }
        
        if (!hasStock && window.globalState && window.globalState.currentTicker) {
            hasStock = true;
        }
        
        updateStockSelectionState(hasStock);
    }

    checkStockSelection();

    const scene = document.querySelector('a-scene');
    if (scene) {
        scene.addEventListener('profile-data-updated', (e) => {
            console.log(`ks: receive data`, e.detail);
            updateStockSelectionState(true);
            updateTab(e.detail);
        })
        
        scene.addEventListener('stock-selected', () => {
            checkStockSelection();
        });
    }

    setInterval(checkStockSelection, 1000);
    document.addEventListener('tab-changed', (e) => {
        if (e.detail && e.detail.tabIndex === 2) {
            setTimeout(checkStockSelection, 100);
        }
    });


    function updateTab(updateData) {
        console.log('ks: update profile tab', updateData);
        const textFields = ['companyName', 'ticker', 'description', 'address', 'employees', 'exchange', 'type'];
        textFields.forEach((field) => {
            if (htmlElements[field] && updateData[field]) {
                if (field === 'description') {
                    htmlElements[field].dataset.fullDescription = updateData[field];
                    updateDescriptionText();
                } else {
                    htmlElements[field].textContent = updateData[field];
                }
            }
        })

        if (htmlElements.logo && updateData.companyLogo) {
            htmlElements.logo.style.display = ''; // Reset visibility before setting new src
            htmlElements.logo.src = updateData.companyLogo;
        } else if (htmlElements.logo) {
            htmlElements.logo.style.display = 'none';
        }
        if (!updateData.sectorId) return
        const sectorsList = [
            { id: 1, name: 'Utilities', iconName: 'Utilities.svg', color: '#00C4B3', isActive: true },
            { id: 2, name: 'Energy', iconName: 'Energy.svg', color: '#ACACAC', isActive: true },
            { id: 3, name: 'Materials', iconName: 'Materials.svg', color: '#697AB6', isActive: true },
            { id: 4, name: 'Financials', iconName: 'Financials.svg', color: '#C8C8C8', isActive: true },
            { id: 5, name: 'Health Care', iconName: 'Health-Care.svg', color: '#E54360', isActive: true },
            { id: 6, name: 'Real Estate', iconName: 'Materials.svg', color: '#CAD1EA', isActive: true },
            { id: 7, name: 'Information-Technology', iconName: 'Information-Technology.svg', color: '#00945E', isActive: true },
            { id: 8, name: 'Industrials', iconName: 'Industrials.svg', color: '#3636E3', isActive: true },
            { id: 9, name: 'Communication Services', iconName: 'Communication-Services.svg', color: '#697AB6', isActive: true },
            { id: 10, name: 'Consumer Staples', iconName: 'Consumer-Staples.svg', color: '#6993DE', isActive: true },
            { id: 11, name: 'Consumer Discretionary', iconName: 'Customer-Discretionary.svg', color: '#FFC629', isActive: true },
        ]
        const currentSector = sectorsList.find(sector => sector.id === updateData.sectorId);
        htmlElements.sectorLogo.src = `./desktop_assets/pop-up/sectors/${currentSector.iconName}`;
        htmlElements.sectorName.textContent = updateData.sector || currentSector.name;
        htmlElements.sectorDot.style.backgroundColor = currentSector.color
    }

    function updateDescriptionText() {
        if (!htmlElements.description) return;
        
        const fullDescription = htmlElements.description.dataset.fullDescription;
        if (!fullDescription || fullDescription === 'empty') return;
        
        const rightWrapper = document.querySelector('.right-wrapper');
        const isFullscreen = rightWrapper && rightWrapper.classList.contains('financials-expanded');
        
        if (isFullscreen) {
            htmlElements.description.textContent = fullDescription;
        } else {
            if (fullDescription.length > 80) {
                htmlElements.description.textContent = fullDescription.substring(0, 80) + '...';
            } else {
                htmlElements.description.textContent = fullDescription;
            }
        }
    }

    const rightWrapper = document.querySelector('.right-wrapper');
    if (rightWrapper) {
        const observer = new MutationObserver(() => {
            updateDescriptionText();
        });
        observer.observe(rightWrapper, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

})
